import { useGetPrograms } from '../api/useGetPrograms';
import { SummaryCard } from './SummaryCard';
import { programStatus } from '../lib/programStatus';

const ALL_LIMIT = 500;

export const ProgramKpis = () => {
  const { data, isLoading, isError } = useGetPrograms({ page: 0, limit: ALL_LIMIT });

  const programs = data?.payload?.programs ?? [];
  const total = data?.payload?.total ?? 0;
  const live = programs.filter((p) => programStatus(p) === 'Live').length;
  const upcoming = programs.filter((p) => programStatus(p) === 'Upcoming').length;
  const incomplete = total > programs.length;

  if (isError) return null;

  return (
    <div className="flex flex-col gap-1">
      <div className="flex gap-4">
        <SummaryCard label="Total Programs" value={total.toLocaleString()} loading={isLoading} />
        <SummaryCard label="Live now" value={live.toLocaleString()} loading={isLoading} />
        <SummaryCard label="Upcoming" value={upcoming.toLocaleString()} loading={isLoading} />
      </div>
      {incomplete && (
        <span className="text-xs text-gray-400">
          Live/Upcoming counted over the first {programs.length} of {total} programs.
        </span>
      )}
    </div>
  );
};
